<template>
<v-layout row wrap>
<!-- <v-flex xs12 sm6 offset-sm3> -->
  <v-flex xs6>
    <v-card class="card--flex-toolbar ma-2" height="95%">
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">점검자 목록</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="$_assign">save</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>
      <v-progress-linear v-show="leftLoading" color="blue" indeterminate height="2" style="margin: 0 auto"/>

      <div style="max-height:70vh;" class="scroll-y">
        <template v-for="checker in checkers">
          <v-card :key="checker.id" :dark="checker.changed ? true : false">
            <v-card-title>{{checker.name}}</v-card-title>
            <v-card-text>
                <draggable v-model="checker.places" group="places" style="min-height:20px;" @change="$_onChange($event, checker)">
                  <template v-for="place in checker.places">
                    <v-chip v-if="place.moved" :key="place.id" color="primary" text-color="white">
                      {{place.name}}
                    </v-chip>
                    <v-chip v-else :key="place.id">
                      {{place.name}}
                    </v-chip>
                  </template>
                </draggable>
            </v-card-text>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-flex>
  <v-flex xs6>
    <v-card class="card--flex-toolbar ma-2" height="95%">
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">충전소 목록</v-toolbar-title>
      </v-toolbar>

      <v-divider></v-divider>
      <v-progress-linear v-show="rightLoading" color="blue" indeterminate height="2" style="margin: 0 auto"/>

      <v-card-text style="max-height:70vh;" class="scroll-y">
        <draggable v-model="places" group="places" style="min-height:20px">
          <template v-for="place in places">
            <v-chip v-if="place.moved" :key="place.id" color="primary" text-color="white" @change="$_onChange($event)">
              {{place.name}}
            </v-chip>
            <v-chip v-else :key="place.id" >
              {{place.name}}
            </v-chip>
          </template>
        </draggable>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import draggable from 'vuedraggable'

export default {
  name: 'PlaceAssign',
  components: {
    draggable
  },
  data () {
    return {
      checkers: [],
      places: [],
      leftLoading: false,
      rightLoading: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getDatas()
    }
  },
  created () {
    this.$emit('title', '구성 (점검자 - 충전소)')
    this.$_getDatas()
  },
  methods: {
    async $_getDatas () {
      this.checkers = []
      this.places = []

      try {
        // let [checkersSnapshot, placesSnapshot] = await Promise.all([this.$fs.collection('checkers').where('group', '==', this.$store.state.session.group).orderBy('name').get(),
        //  this.$fs.collection('places').orderBy('name').where('group', '==', this.$store.state.session.group).get()])

        this.leftLoading = true
        let checkersSnapshot
        if (this.$DEBUG) {
          checkersSnapshot = await this.$fs.collection('checkers').orderBy('name').get()
        } else {
          checkersSnapshot = await this.$fs.collection('checkers').where('group', '==', this.$store.state.session.group).orderBy('name').get()
        }

        checkersSnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

          var item = doc.data()
          item.id = doc.id
          item.places = []
          this.checkers.push(item)
        }) // forEach

        this.rightLoading = true
        let placesSnapshot
        if (this.$DEBUG) {
          placesSnapshot = await this.$fs.collection('places').orderBy('name').get()
        } else {
          placesSnapshot = await this.$fs.collection('places').where('group', '==', this.$store.state.session.group).orderBy('name').get()
        }

        this.places = []
        placesSnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

          var item = doc.data()
          item.id = doc.id

          // checkers 에서 ref 가 있는지 확인 후 mapping
          var checker = this.checkers.find(checker => {
            if (checker.placeRefs) {
              for (var i = 0; i < checker.placeRefs.length; i++) {
                if (checker.placeRefs[i].id === item.id) {
                  return checker
                }
              }
            }
            return null
          })

          if (checker) {
            checker.places.push(item)
          } else {
            this.places.push(item)
          }
        })
      } catch (error) {
        this.$emit('snackbar', '점검자-충전소 정보를 가져오지 못하였습니다.')
        console.log(error)
      }

      this.leftLoading = false
      this.rightLoading = false
    },
    $_onChange (evt, checker) {
      let place

      if (evt.added) {
        place = evt.added.element
      } else if (evt.removed) {
        place = evt.removed.element
      } else if (evt.moved) {
        // place = evt.moved.element
        return true
      }

      place.moved = true

      if (checker) {
        checker.changed = true
        checker.places = [...checker.places] // vue 에서 바로 변형 감지가 안되어 배열 복사하여 UI 바로 업데이트 함.
      }

      return true
    },
    $_assign () {
      let batch = this.$fs.db().batch()

      // 점검자에 충전소 할당
      this.checkers.forEach(checker => {
        if (checker.changed) {
          let checkerRef = this.$fs.collection('checkers').doc(checker.id)

          if (checker.places.length > 0) {
            let newPlaceRefs = [] // 최종 반영할 충전소목록
            for (let i = 0; i < checker.places.length; i++) { // 각 점검자가 가지고 있는 장소 정보들
              let newPlaceRef = this.$fs.collection('places').doc(checker.places[i].id)

              batch.update(newPlaceRef, {'checkerRef': checkerRef,
                updated: firebase.firestore.FieldValue.serverTimestamp()}) // 각 장소에도 점검자 정보를 업데이트 (양방향 조회 지원)

              newPlaceRefs.push(newPlaceRef) // for 이후 한번에 저장할 장소 정보
            }

            batch.update(checkerRef, {'placeRefs': newPlaceRefs,
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          } else {
            batch.update(checkerRef, {'placeRefs': firebase.firestore.FieldValue.delete(),
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          }
        }
      })

      // 이동된 장소에서 점검자 정보 삭제
      this.places.forEach(place => {
        if (place.moved) {
          let placeRef = this.$fs.collection('places').doc(place.id)

          batch.update(placeRef, {'checkerRef': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})
        }
      })

      /* // 전체 점검자목록을 반복하면서 (사람:장소 == 1:N)
      this.checkers.forEach(checker => {
        var checkerRef = this.$fs.collection('checkers').doc(checker.id)

        if (checker.placeRefs) { // 기존 정보들은 우선 제거
          checker.placeRefs.forEach((placeRef, index, array) => { // 각각의 place 에서 checker 정보 제거, checker 에서 place 정보 변경은 아래에서
            batch.update(placeRef, {'checkerRef': firebase.firestore.FieldValue.delete(),
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          })

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }

        var newPlaceRefs = [] // 최종 반영할 충전소목록
        for (var i = 0; i < checker.places.length; i++) { // 각 점검자가 가지고 있는 장소 정보들
          var newPlaceRef = this.$fs.collection('places').doc(checker.places[i].id)
          newPlaceRefs.push(newPlaceRef) // for 이후 한번에 저장할 장소 정보

          batch.update(newPlaceRef, {'checkerRef': checkerRef,
            updated: firebase.firestore.FieldValue.serverTimestamp()}) // 각 장소에도 점검자 정보를 업데이트 (양방향 조회 지원)

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }

        if (newPlaceRefs.length > 0) {
          batch.update(checkerRef, {'placeRefs': newPlaceRefs,
            updated: firebase.firestore.FieldValue.serverTimestamp()})

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        } else {
          batch.update(checkerRef, {'placeRefs': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }

        // console.log(checker.places)
      }) */

      // Commit the batch
      batch.commit()
        .then(() => {
          this.$emit('snackbar', '저장 되었습니다.')
          console.log('success')

          this.$_getDatas() // reset
        })
        .catch(error => {
          this.$emit('snackbar', '오류발생으로 저장하지 못하였습니다.')
          console.log('error', error)

          this.$_getDatas() // reset
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Place/PlaceAssign.vue